import jqRequest from '../jqRequest'
import specialUrls from '../urls/special'

export default {
  // 获取专题详细信息
  getSpecialContentById(data) {
    return jqRequest.requestWithToken(specialUrls.getSpecialContentById, data);
  },
  // 获取专题下的内容分类列表
  getSpecialById(data) {
    return jqRequest.requestWithToken(specialUrls.getSpecialById, data);
  },
  // 专题内容列表
  getSpecialContentsByClassifyId(data) {
    return jqRequest.requestWithToken(specialUrls.getSpecialContentsByClassifyId, data);
  },
  // 获取专栏详细信息
  getSpecialContentsForColumn(data) {
    return jqRequest.requestWithToken(specialUrls.getSpecialContentsForColumn, data);
  },
}